import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品服务',
    items: [
      { label: '企业解决方案', path: '/categories' },
      { label: '技术平台', path: '/categories' },
      { label: '营销增长', path: '/categories' },
      { label: '数据智能', path: '/categories' },
    ],
  },
  resources: {
    title: '资源中心',
    items: [
      { label: '行业洞察', path: '/articles' },
      { label: '产品动态', path: '/articles' },
      { label: '帮助文档', path: '/about' },
      { label: 'API文档', path: '/about' },
    ],
  },
  company: {
    title: '关于我们',
    items: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '加入我们', path: '/about' },
      { label: '合作伙伴', path: '/about' },
    ],
  },
  support: {
    title: '支持服务',
    items: [
      { label: '常见问题', path: '/about' },
      { label: '技术支持', path: '/about' },
      { label: '服务协议', path: '/about' },
      { label: '隐私政策', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            {Object.values(footerLinks).map((section) => (
              <div key={section.title}>
                <h3 className="font-label font-semibold text-sm text-background-50 mb-5 tracking-wide uppercase">
                  {section.title}
                </h3>
                <ul className="space-y-3">
                  {section.items.map((item) => (
                    <li key={item.label}>
                      <Link
                        to={item.path}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-14 pt-8 border-t border-foreground-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <span className="text-background-50 font-heading font-bold text-base">b</span>
                </div>
                <span className="font-heading font-bold text-lg text-background-100">btbxx</span>
              </div>

              <div className="flex items-center gap-6">
                <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener noreferrer" className="text-background-400 hover:text-background-100 transition-colors duration-200" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="https://weibo.com" target="_blank" rel="nofollow noopener noreferrer" className="text-background-400 hover:text-background-100 transition-colors duration-200" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="text-background-400 hover:text-background-100 transition-colors duration-200" aria-label="领英">
                  <i className="ri-linkedin-line text-lg"></i>
                </a>
                <a href="https://github.com" target="_blank" rel="nofollow noopener noreferrer" className="text-background-400 hover:text-background-100 transition-colors duration-200" aria-label="GitHub">
                  <i className="ri-github-line text-lg"></i>
                </a>
              </div>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-background-500">
                &copy; {new Date().getFullYear()} btbxx. 保留所有权利。
              </p>
              <div className="flex items-center gap-4">
                <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">
                  隐私政策
                </Link>
                <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">
                  服务条款
                </Link>
                <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200">
                  联系我们
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}